export type BlockTone = {
  key: string;
  label: string;
  bg: string;
  bgDark: string;
  line: string;
  lineDark: string;
  ink: string;
  inkDark: string;
  swatch: string;
  swatchDark: string;
};

export const BLOCK_TONES: Record<string, BlockTone> = {
  blockDeep: {
    key: 'blockDeep', label: 'Deep Work',
    bg: 'oklch(0.95 0.03 255)', bgDark: 'oklch(0.38 0.10 255)',
    line: 'oklch(0.75 0.10 255)', lineDark: 'oklch(0.6 0.15 255)',
    ink: 'oklch(0.32 0.12 255)', inkDark: '#ffffff',
    swatch: 'oklch(0.72 0.12 255)', swatchDark: 'oklch(0.6 0.17 255)',
  },
  blockMeeting: {
    key: 'blockMeeting', label: 'Meeting',
    bg: 'oklch(0.94 0.03 300)', bgDark: 'oklch(0.38 0.09 300)',
    line: 'oklch(0.74 0.08 300)', lineDark: 'oklch(0.58 0.12 300)',
    ink: 'oklch(0.33 0.10 300)', inkDark: '#ffffff',
    swatch: 'oklch(0.68 0.12 300)', swatchDark: 'oklch(0.58 0.15 300)',
  },
  blockAdmin: {
    key: 'blockAdmin', label: 'Admin',
    bg: '#f1f0ed', bgDark: '#42423f',
    line: '#d0ceca', lineDark: '#6e6e6a',
    ink: '#4a4945', inkDark: '#ffffff',
    swatch: '#a8a69f', swatchDark: '#8a8886',
  },
  blockBuffer: {
    key: 'blockBuffer', label: 'Puffer',
    bg: 'oklch(0.94 0.03 150)', bgDark: 'oklch(0.38 0.08 150)',
    line: 'oklch(0.76 0.07 150)', lineDark: 'oklch(0.58 0.12 150)',
    ink: 'oklch(0.33 0.08 150)', inkDark: '#ffffff',
    swatch: 'oklch(0.7 0.11 150)', swatchDark: 'oklch(0.58 0.14 150)',
  },
  blockLunch: {
    key: 'blockLunch', label: 'Lunch',
    bg: 'oklch(0.95 0.04 75)', bgDark: 'oklch(0.4 0.08 75)',
    line: 'oklch(0.78 0.08 75)', lineDark: 'oklch(0.6 0.12 75)',
    ink: 'oklch(0.38 0.09 75)', inkDark: '#ffffff',
    swatch: 'oklch(0.74 0.11 75)', swatchDark: 'oklch(0.62 0.14 75)',
  },
  blockPersonal: {
    key: 'blockPersonal', label: 'Persönlich',
    bg: 'oklch(0.95 0.03 25)', bgDark: 'oklch(0.4 0.1 25)',
    line: 'oklch(0.78 0.09 25)', lineDark: 'oklch(0.62 0.14 25)',
    ink: 'oklch(0.4 0.13 25)', inkDark: '#ffffff',
    swatch: 'oklch(0.74 0.13 25)', swatchDark: 'oklch(0.62 0.16 25)',
  },
  blockCreative: {
    key: 'blockCreative', label: 'Kreativ',
    bg: 'oklch(0.94 0.03 195)', bgDark: 'oklch(0.38 0.08 195)',
    line: 'oklch(0.74 0.08 195)', lineDark: 'oklch(0.58 0.12 195)',
    ink: 'oklch(0.33 0.09 195)', inkDark: '#ffffff',
    swatch: 'oklch(0.7 0.11 195)', swatchDark: 'oklch(0.58 0.14 195)',
  },
  blockLearning: {
    key: 'blockLearning', label: 'Lernen',
    bg: 'oklch(0.94 0.03 270)', bgDark: 'oklch(0.38 0.09 270)',
    line: 'oklch(0.74 0.09 270)', lineDark: 'oklch(0.58 0.13 270)',
    ink: 'oklch(0.34 0.10 270)', inkDark: '#ffffff',
    swatch: 'oklch(0.68 0.13 270)', swatchDark: 'oklch(0.58 0.16 270)',
  },
  blockSocial: {
    key: 'blockSocial', label: 'Sozial',
    bg: 'oklch(0.94 0.03 340)', bgDark: 'oklch(0.4 0.09 340)',
    line: 'oklch(0.76 0.08 340)', lineDark: 'oklch(0.6 0.12 340)',
    ink: 'oklch(0.38 0.10 340)', inkDark: '#ffffff',
    swatch: 'oklch(0.72 0.12 340)', swatchDark: 'oklch(0.6 0.15 340)',
  },
  blockFitness: {
    key: 'blockFitness', label: 'Sport',
    bg: 'oklch(0.94 0.03 45)', bgDark: 'oklch(0.4 0.09 45)',
    line: 'oklch(0.77 0.09 45)', lineDark: 'oklch(0.6 0.13 45)',
    ink: 'oklch(0.38 0.11 45)', inkDark: '#ffffff',
    swatch: 'oklch(0.72 0.12 45)', swatchDark: 'oklch(0.6 0.15 45)',
  },
  blockTravel: {
    key: 'blockTravel', label: 'Reise',
    bg: 'oklch(0.94 0.03 220)', bgDark: 'oklch(0.38 0.08 220)',
    line: 'oklch(0.74 0.08 220)', lineDark: 'oklch(0.58 0.12 220)',
    ink: 'oklch(0.33 0.09 220)', inkDark: '#ffffff',
    swatch: 'oklch(0.68 0.11 220)', swatchDark: 'oklch(0.58 0.14 220)',
  },
  blockRoutine: {
    key: 'blockRoutine', label: 'Routine',
    bg: 'oklch(0.94 0.02 110)', bgDark: 'oklch(0.4 0.07 110)',
    line: 'oklch(0.76 0.07 110)', lineDark: 'oklch(0.58 0.10 110)',
    ink: 'oklch(0.35 0.08 110)', inkDark: '#ffffff',
    swatch: 'oklch(0.7 0.1 110)', swatchDark: 'oklch(0.58 0.12 110)',
  },
};

export const BLOCK_CAT_ORDER = [
  'blockDeep', 'blockMeeting', 'blockAdmin', 'blockBuffer', 'blockLunch', 'blockPersonal',
  'blockCreative', 'blockLearning', 'blockSocial', 'blockFitness', 'blockTravel', 'blockRoutine',
] as const;

export function toneFor(cat: string): BlockTone {
  return BLOCK_TONES[cat] ?? BLOCK_TONES.blockAdmin;
}
